export function getCurrentThread(state) {
    return state.getIn(['threads', state.get('currentThread')]);
}

export function isThreadFileLoading(state) {
    return [
        XMLHttpRequest.OPENED,
        XMLHttpRequest.HEADERS_RECEIVED,
        XMLHttpRequest.LOADING,
    ].includes(state.getIn(['threadFileUploadMeta', 'readyState']));
}
